"use client"

import AppRootLayoutSkeleton from "@/components/layouts/AppRootLayout/index.skeleton"

const RootLoading = () => {
  return (
    <AppRootLayoutSkeleton />
  )
}

export default RootLoading